/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
export type AutoStakingStatusFragmentFragment = { __typename?: "AutoStaking"; enabled: boolean };

export const AutoStakingStatusFragmentFragmentDoc = gql`
	fragment AutoStakingStatusFragment on AutoStaking {
		enabled
	}
`;
